import { storageFor } from 'ember-local-storage';
import { tryStorage } from 'ember-local-storage/helpers/storage';
import Service from '@ember/service';
import { ProductTour } from 'cio/utils/product-tour';

export default class ProductTourService extends Service {
  @storageFor('cio-alerts') localStorage!: any;

  tour(name: string, steps: number) {
    let storageWriteable = tryStorage('local');

    return ProductTour.create({ name, steps, localStorage: storageWriteable ? this.localStorage : null });
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'product-tour': ProductTourService;
  }
}
